module.exports = __webpack_public_path__ + "static/media/07.bc381b73.jpg";